import React from "react";
import { toScoreValue } from "../../utils/scoreState";
import {
  getScaleValueLabel,
  getScaleValues,
  getScorePillProps,
} from "../../utils/scoringScale";

// Score input for one subheading. The values offered are the ones the
// heading's scoring scale defines — 1-5 for POMMe-Health, 0-4 for ICF, 1-10 for
// the ten-point scale — plus an explicit "n/a". A score and n/a are mutually
// exclusive: handleGrade(subheadingId, score, notApplicable) is called with
// either a number and false, or null and true.
//
// The pills are rendered from the scale's values, never from a range: the
// values are not guaranteed to be contiguous or to start at 1.
const Grade = ({
  handleGrade,
  item,
  group,
  score,
  notApplicable = false,
  isEdit,
  scale,
}) => {
  const values = getScaleValues(scale);
  const selectedScore = notApplicable ? null : toScoreValue(score, scale);

  const getInputId = (gradeValue) => `${group}-${item}-${gradeValue}`;

  return (
    <>
      {values.map((gradeValue) => {
        const { className, style } = getScorePillProps(scale, gradeValue);
        const label = getScaleValueLabel(scale, gradeValue);
        return (
          <div
            className={`form-check ${className} d-inline-flex align-items-center flex-nowrap pr-2 rounded-pill mx-2 mx-sm-1 mt-1 mt-sm-1 mt-md-1 mt-lg-0`}
            key={gradeValue}
            style={{ flex: "0 0 auto", ...style }}
            title={label || undefined}
          >
            <input
              className="form-check-input ml_1"
              type="radio"
              id={getInputId(gradeValue)}
              onChange={() => handleGrade(item, gradeValue, false)}
              name={group}
              required
              {...(selectedScore === gradeValue && { checked: true })}
              disabled={!isEdit}
            />
            <small
              className="form-check-label pl-4"
              htmlFor={getInputId(gradeValue)}
            >
              {gradeValue}
            </small>
          </div>
        );
      })}
      <div
        className="form-check border d-inline-flex align-items-center flex-nowrap pr-2 rounded-pill mx-2 mx-sm-1 mt-1 mt-sm-1 mt-md-1 mt-lg-0"
        style={{ flex: "0 0 auto" }}
      >
        <input
          className="form-check-input ml_1"
          type="radio"
          onChange={() => handleGrade(item, null, true)}
          id={getInputId("na")}
          name={group}
          required
          {...(notApplicable && { checked: true })}
          disabled={!isEdit}
        />
        <small
          className="form-check-label pl-4 text-muted"
          htmlFor={getInputId("na")}
        >
          n/a
        </small>
      </div>
    </>
  );
};

export default Grade;
